module.exports = __webpack_public_path__ + "img/icon06.7f482ef0.png";